import type { ReactNode } from 'react';

import { Avatar, AvatarFallback } from '@/common/components/ui/avatar';
import { formatTime } from '@/common/utils/DateFormatters';
import { getInitials } from '@/common/utils/UserUtils';

type NoteCardProps = {
  createdByName: string;
  createdAt: Date;
  actions?: ReactNode;
  children: ReactNode;
};

const NoteCard = ({
  createdByName,
  createdAt,
  actions,
  children,
}: NoteCardProps) => {
  return (
    <div className="flex flex-col gap-2 bg-warm-gray-50 rounded-lg px-4 py-3">
      <div className="flex items-start gap-2">
        <Avatar className="w-7 h-7 mt-1">
          <AvatarFallback className="bg-ring text-primary-foreground text-xs">
            {getInitials(createdByName)}
          </AvatarFallback>
        </Avatar>

        <div className="flex flex-col items-baseline">
          <span className="text-sm">{createdByName}</span>
          <span className="text-xxs text-foreground">
            {formatTime(createdAt)}
          </span>
        </div>

        {actions && <div className="ml-auto flex">{actions}</div>}
      </div>

      {children}
    </div>
  );
};

export default NoteCard;
